// Ashra's Reading Collection - Books Already Read! 📚

export interface Book {
  id: number;
  title: string;
  rating: number;
  emoji: string;
  dateRead: string;
  favoriteCharacter?: string;
}

export interface Trip {
  id: number;
  destination: string;
  date: string;
  emoji: string;
  highlights: string;
  favoriteMemory?: string;
}

export interface Hobby {
  id: number;
  name: string;
  emoji: string;
  description: string;
  level: string; // Beginner, Learning, Expert
  startedDate: string;
}

export const INITIAL_BOOKS: Book[] = [
  {
    id: 1,
    title: "The Very Hungry Caterpillar",
    rating: 5,
    emoji: "🦋",
    dateRead: "2025-11-15",
    favoriteCharacter: "The Caterpillar"
  },
  {
    id: 3,
    title: "Charlotte's Web",
    rating: 5,
    emoji: "🕷️",
    dateRead: "2025-11-28",
    favoriteCharacter: "Charlotte"
  },
  {
    id: 4,
    title: "The Rainbow Fish",
    rating: 4,
    emoji: "🌈",
    dateRead: "2025-12-01",
    favoriteCharacter: "Rainbow Fish"
  },
  {
    id: 5,
    title: "Diary of a Wimpy Kid",
    rating: 5,
    emoji: "📖",
    dateRead: "2025-12-05",
    favoriteCharacter: "Greg"
  },
  {
    id: 6,
    title: "The Magic Tree House",
    rating: 4,
    emoji: "🌳",
    dateRead: "2025-12-08",
    favoriteCharacter: "Jack and Annie"
  }
];

// Initial trips and travels data
export const INITIAL_TRIPS: Trip[] = [
  {
    id: 0,
    destination: "Disney World",
    date: "Apr 2026",
    emoji: "🏰",
    highlights: "Rides, parades, face painting and meeting characters",
    favoriteMemory: "Seeing the fireworks show!"
  },
  {
    id: 1,
    destination: "Beach Vacation",
    date: "2025-07-15",
    emoji: "🏖️",
    highlights: "Building sandcastles, swimming in the ocean",
    favoriteMemory: "Finding beautiful seashells!"
  },
  {
    id: 2,
    destination: "Zoo Adventure",
    date: "2025-09-10",
    emoji: "🦁",
    highlights: "Saw lions, giraffes, and penguins",
    favoriteMemory: "Feeding the friendly goats!"
  },
  {
    id: 4,
    destination: "Tugaloo State Park",
    date: "Apr 2026",
    emoji: "🏞️",
    highlights: "Playing by the lake, volley ball, and burrying Evvi in the sand",
    favoriteMemory: "Hanging out with friends and family in the tent!"
  }
];

// Initial hobbies data
export const INITIAL_HOBBIES: Hobby[] = [
  {
    id: 1,
    name: "Drawing & Painting",
    emoji: "🎨",
    description: "I love drawing princesses and rainbows!",
    level: "Learning",
    startedDate: "2024-01-15"
  },
  {
    id: 2,
    name: "Dancing",
    emoji: "💃",
    description: "Ballet and freestyle dancing to my favorite songs",
    level: "Expert",
    startedDate: "2023-06-10"
  },
  {
    id: 3,
    name: "Crafting",
    emoji: "✂️",
    description: "Making friendship bracelets and decorations",
    level: "Learning",
    startedDate: "2025-03-20"
  },
  {
    id: 4,
    name: "Gardening",
    emoji: "🌻",
    description: "Planting flowers and vegetables in the backyard",
    level: "Beginner",
    startedDate: "2026 March"
  }
];

// Fun messages to show when adding a book
export const FUN_MESSAGES = [
  "WOW! Another book conquered! 🎉",
  "Bookworm alert! 🐛📚",
  "You're on FIRE! 🔥📖",
  "Reading superstar! ⭐",
  "Book champion! 🏆",
  "Amazing job, Ashra! 🌟",
  "Keep those pages turning! 📚",
  "You're unstoppable! 💪📖",
];

// Fun messages for trips
export const TRIP_MESSAGES = [
  "What an adventure! 🎉",
  "Amazing memories made! ✨",
  "Explorer extraordinaire! 🗺️",
  "Travel superstar! ⭐",
  "Adventure unlocked! 🏆",
];

// Emoji options for book selection
export const BOOK_EMOJIS = [
  '📚', '📖', '📕', '📗', '📘', '📙',
  '🦄', '🌈', '⭐', '🎨', '🎭', '🎪',
  '🎈', '🦋', '🌸', '🌳', '🕷️', '🐛',
  '🎯', '🎪', '🦊', '🐼', '🌻', '🎀'
];

// Emoji options for trip selection
export const TRIP_EMOJIS = [
  '🏖️', '🗼', '🏰', '🎢', '🎡', '🎠',
  '🏔️', '🏕️', '🚂', '✈️', '🚗', '🏝️',
  '🦁', '🐘', '🦒', '🏡', '🏛️', '🎭',
  '🎪', '🎨', '🌊', '🌴', '⛱️', '🗺️'
];

// Emoji options for hobby selection
export const HOBBY_EMOJIS = [
  '🎨', '🎭', '🎪', '🎬', '🎤', '🎧',
  '🎹', '🎸', '🎺', '🎻', '💃', '🕺',
  '⚽', '🏀', '🏊', '🚴', '⛸️', '🛹',
  '✂️', '🧵', '🪡', '🎯', '🎲', '🧩'
];
